/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './objectRestoreInfo.tpl.html';

angular
  .module('batch.objectRestore.info', ['ngSanitize', 'services.view'])
  /**
   * Controller for the batch.objectRestore.info template.
   */
  .controller(
    'ObjectRestoreInfoCtrl',
    function ($scope, $filter, $state, httpBatch, lastState, viewUtils, VIEW_STATES) {
      var currentBatch = $scope.batchUtils.currentBatch,
        batchDate;

      $scope.batchUtils.currentBatch.userEmail = $scope.batchUtils.currentBatch.objectRestoreData
        ? $scope.batchUtils.currentBatch.objectRestoreData.username
        : '';

      /**
       * Utility function for returning to the previous state.
       */
      $scope.goBack = function () {
        viewUtils.resetState($state.current.name);
        $state.go(lastState || VIEW_STATES.LOG_HOME);
      };

      /**
       * Utility function for showing the backup view.
       */
      $scope.goToBatch = function () {
        // Set the current batch to the retrieved origin batch and
        // show the batch view.
        $scope.batchUtils.currentBatch = $scope.originBatch;
        $state.go(VIEW_STATES.BATCH_HOME);
      };

      // If a currentBatch is not set redirect app to the admin view.
      if (_.isEmpty(currentBatch) || currentBatch.type !== 'OBJECT_RESTORE') {
        $scope.goBack();
      } else {
        $scope.boinkCls =
          $scope.batchUtils.currentBatch.status && $scope.batchUtils.STATUS[$scope.batchUtils.currentBatch.status]
            ? $scope.batchUtils.STATUS[$scope.batchUtils.currentBatch.status].bigBoinkCls
            : '';
        batchDate = moment(currentBatch.date);
        $scope.batchDate = $filter('i18n')('BATCH_DETAIL_DATE', [
          batchDate.format(SBSF.messages.M_D_Y),
          batchDate.format(SBSF.messages.H_M),
          $filter('i18n')('RESTORE')
        ]);
      }

      /**
       * Handler for the control to show and hide the error/warning messages.
       */
      $scope.toggleMessages = function () {
        $scope.$parent.showMessages = !$scope.$parent.showMessages;
      };
    }
  );
